import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  FormText
} from "reactstrap"
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import useForm from "../../lib/useForm"
import Loading from 'lib/loading'
import ListaControles from "./permissoes"
import NumberFormat from 'react-number-format';
import FormUsuario from "views/Cadastros/Usuarios/formUsuario"
//import FormUsuario from "./formUsuario"

const Usuario = () => {

  const inicialForm = {
    usuario_id:     '',
    usuario:        '',
    cpf:            '',
    email:          '',
    parceiro_id:    '',
    perfil_id:      '',
    ativo:          'S',
    senha:          '',
    confirma_senha: '',
    perfilSelect:   ''
  }

  const [form, onChange, setForm, onChangeSelect] = useForm(inicialForm)
  const [loading, setLoading]                     = useState(true)
  const [activeTab, setActiveTab]                 = useState('1')
  const [perfil, setPerfil]                       = useState([])
  const [validacao, setValidacao]                 = useState('')
  const [usuarioId, setUsuarioId]                 = useState('')

  // const listaUsuarios = () => {
  //   console.log(rotas.usuarios)
  //   let lista = []
  //   try{
  //     const retorno = rest.get(rotas.usuarios + '6')
  //     retorno.then(ret => {
  //       // console.log(ret)
  //       if (ret.success && ret.success == 'S'){
  //         lista = ret.lista[0]
  //         listaPerfil(ret.lista[0].perfil_id)
  //         setForm(lista)

  //       }
  //       setLoading(false)
  //     })
  //     return (lista)
  //   }catch(err){

  //   }
  // }

  useEffect(() => {
    if(usuarioId === ''){
      setUsuarioId(sessionStorage.getItem('usuario_id'))
    }
    setLoading(false)
  },[])

  // const listaPerfil = (perfil_id) => {
  //   try{
  //     const retorno = rest.get(rotas.perfil_cad+perfil_id)
  //     retorno.then(ret => {
  //       // console.log(ret)
  //       if (ret.success && ret.success == 'S' && ret.lista != ''){
  //         setPerfil(ret.lista[0])
  //       }
  //     })
  //     // setLoading(false)
  //     return (true)
  //   }catch(err){
  //     return (false)
  //   }
  // }

  // let verifyLength = (value, length) => {
  //   if ((value.length > 0 && (value.length < length))) {
  //     return true;
  //   }
  //   return false;
  // };

  // let compare = (string1, string2) => {
  //   if (string1 !== string2) {
  //     return true;
  //   }
  //   return false;
  // };

  // useEffect(() => {
  //   const load = loading
  //   if (load === true) {
  //     listaUsuarios()
  //   }
  // }, [])

  if (loading) {
    return (
      <Loading tipo='paginas' />
    )
  }else{
    return(
      <FormUsuario
        usuario_id={usuarioId}
      ></FormUsuario>
    )
  }
}

export default Usuario
